import { useTranslation } from 'react-i18next';
import { ChangeEvent, useContext } from 'react';
import { Form, FormContext, Flex, Input } from 'dash-ui';

import { FormFields } from 'containers/properties/PropertyGeneralInformation/components/PropertyGeneralInfoForm/constants/constants';

const ContactUrlInput = ({
  saleTeamIndex,
  disabled,
}: {
  saleTeamIndex: number;
  disabled?: boolean;
}) => {
  const { t } = useTranslation(['forms', 'common', 'pages']);
  const { formState, formErrors, stateHandlers } = useContext(FormContext);

  const { saleTeamId, contactUrl } =
    formState[FormFields.SaleTeams][saleTeamIndex] || {};

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    const saleTeams = [...formState[FormFields.SaleTeams]];

    saleTeams[saleTeamIndex] = {
      ...saleTeams[saleTeamIndex],
      contactUrl: e.target.value || '',
    };

    stateHandlers[FormFields.SaleTeams](saleTeams);
  };

  return (
    <Flex flexGrow={1} flexDirection="column">
      <Form.Label>{t('forms:labels.contactUrl')}</Form.Label>
      <Input
        w="100%"
        disabled={!saleTeamId || disabled}
        value={contactUrl || ''}
        placeholder={t('forms:placeholders.contactUrl') || ''}
        onChange={onChange}
        $errorType={
          formErrors[FormFields.SaleTeams]?.[saleTeamIndex]?.contactUrl?.type
        }
      />
      <Form.Feedback
        $errorType={
          formErrors[FormFields.SaleTeams]?.[saleTeamIndex]?.contactUrl?.type
        }
      >
        {formErrors[FormFields.SaleTeams]?.[saleTeamIndex]?.contactUrl?.message}
      </Form.Feedback>
    </Flex>
  );
};

export default ContactUrlInput;
